import React from 'react';
import { Trans } from '@lingui/react/macro';
import StatusReason from './StatusReason';
import { SpecificStatusReasonProps } from '.';

const ClosedStatusReason: React.FC<SpecificStatusReasonProps> = ({ ...rest }) => {
    return (
        <StatusReason
            titleGenerator={(userName) => (userName ? <Trans>Closed by {userName}</Trans> : <Trans>Closed</Trans>)}
            {...rest}
        />
    );
};

export default ClosedStatusReason;


